import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "@hooks/useAppTheme";
import Box from "@memorang/ui/src/components/Box";
import Button from "@memorang/ui/src/components/Button";
import { useTranslation } from "react-i18next";
import { Text, TouchableRipple } from "react-native-paper";

const VerificationLinkExpired = ({
	onSupportContact,
	onLoginRetry,
}: {
	onSupportContact: () => void;
	onLoginRetry: () => void;
}) => {
	const { t } = useTranslation();
	const theme = useAppTheme();

	return (
		<Box justifyContent="center" alignItems="center" gap={24} flex={1}>
			<Icon
				name="alert-circle-outline"
				size={120}
				color={theme.colors.primary}
			/>
			<Box gap={8} alignItems="center">
				<Text variant="titleLarge">
					{t("auth.verify.verificationLinkExpired")}
				</Text>
				<Text variant="bodyLarge" style={{ textAlign: "center" }}>
					{t("auth.verify.verificationLinkExpiredBody")}
				</Text>
			</Box>
			<Button mode="contained" onPress={onLoginRetry}>
				{t("auth.verify.loginAgain")}
			</Button>
			<TouchableRipple onPress={onSupportContact} style={{ padding: 16 }}>
				<Text style={{ color: theme.colors.secondary }}>
					{t("auth.verify.contactSupportExpiredLink")}
				</Text>
			</TouchableRipple>
		</Box>
	);
};

export default VerificationLinkExpired;
